import { render, staticRenderFns } from "./BalancePayDialog.vue?vue&type=template&id=6a1c40e8&scoped=true&lang=pug&"
import script from "./BalancePayDialog.vue?vue&type=script&lang=ts&"
export * from "./BalancePayDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c40e8",
  null
  
)

export default component.exports